import { DomainEventDao, atomWithCursor } from '@rock/db-admin';
import type { DomainEvent, DomainEventId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

const domainEventDao = new DomainEventDao();

export const domainEventsPageState = atomWithCursor<DomainEvent>({
    factory: ({ cursorAtom }) => domainEventDao.domainEventsAtom(50, cursorAtom),
    countFn: () => domainEventDao.countEvents(),
});

/** Live feed of the latest domain events — the Dashboard's Recent Activity strip. */
export const recentDomainEventsState = domainEventDao.domainEventsAtom(10, undefined);

export const domainEventState = atomFamily(
    (eventId: DomainEventId) => domainEventDao.domainEventAtom(eventId),
    shallowEqual,
);

/**
 * Atom that fetches multiple domain events by their IDs.
 * Returns an array of domain events (filters out undefined values).
 */
export const domainEventsByIdsState = atomFamily((eventIds: DomainEventId[] | undefined) => {
    if (!eventIds || eventIds.length === 0) {
        return atom<Promise<DomainEvent[]>>(Promise.resolve([]));
    }

    return atom(async (get) => {
        const eventPromises = eventIds.map((eventId) => get(domainEventState(eventId)));
        const events = await Promise.all(eventPromises);
        return events.filter((e): e is DomainEvent => e !== undefined);
    });
}, shallowEqual);
